import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';

function NetworkWiseReport() {
    const [rowsData, setRowsData] = useState([]);
    const [sortConfig, setSortConfig] = useState({
        key: "name",
        direction: "ascending",
    });
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage] = useState(3);
    const [searchQuery, setSearchQuery] = useState(""); // New state for search query

  
  

    const downloadCSV = () => {
        const headers = [
            "Sl_No", "Status", "Edit", "Select", "Pay", "Name", "Account_No", "Code", "STB_No",
            "D_No", "Flat_Name", "Street", "Mobile_No", "Pay_Status", "Plan_Amount", "Paid_Amount",
            "Paid_Date", "Balance_Amount", "Discount_Amount", "Advance_Amount", "Pending_Amount",
            "Staff_Code", "Network", "Paid_Time", "Packages", "History", "Location", "Collection_Staff", "Delete"
        ];
        const csvRows = [];
        csvRows.push(headers.join(","));
        rowsData.forEach(row => {
            csvRows.push([row.Sl_No, row.Status, row.Edit, row.Select, row.Pay, row.Name, row.Account_No,
            row.Code, row.STB_No, row.D_No, row.Flat_Name, row.Street, row.Mobile_No,
            row.Pay_Status, row.Plan_Amount, row.Paid_Amount, row.Paid_Date, row.Balance_Amount,
            row.Discount_Amount, row.Advance_Amount, row.Pending_Amount, row.Staff_Code, row.Network,
            row.Paid_Time, row.Packages, row.History, row.Location, row.Collection_Staff].join(","));
        });

        const blob = new Blob([csvRows.join("\n")], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", "CableTvPay.csv");
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = rowsData.slice(indexOfFirstRow, indexOfLastRow);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    const totalPages = Math.ceil(rowsData.length / rowsPerPage);

    // Filter rows based on search query across all columns
    const filteredRows = currentRows.filter((row) =>
        Object.values(row).some(value =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase()) // Ensure value is converted to string
        )
    );

    return (
        <div className="content-wrapper">
            {/* Content Header */}
            <div className="content-header pt-1">
                <div className="mt-2">
                    <div className="fs-4 valuesDec h4">
                        NETWORK WISE REPORT
                    </div>
                </div>
                <hr />
                <div className="mt-3 mb-2 mb-lg-5 mx-lg-5">
                    <div className="border-0 px-1">

                        <form action="/allCustomer" method="get">
                            <div className="row mx-3">
                                <div className="col-lg-3 col-md-6 col-12">
                                    <div className="form-group">
                                        <label htmlFor="choose" className="text-center text-navy valuesDec" style={{ borderRadius: "50px" }}>Choose</label>
                                        <select className="form-control bg-gradient-navy  text-light border-0 elevation-3" id="choose" name="choose">
                                            <option value="all">All</option>
                                          
                                        </select>
                                    </div>
                                </div>
                              
                         
                            </div>

                        </form>
                    </div>
                </div>

                <div className="card elevation-5" style={{ backgroundColor: "#cccccc" }}>
                    <div className="card-header filterBtn" >
                        <div className="d-flex justify-content-between">
                            <div >
                                <h4 className=" pb-0 mb-0 mt-1 text-navy">Filter Details</h4>
                            </div>
                            <div className="d-flex justify-content-end btn-group">
                                <button onClick={downloadCSV} className="btn py-1 btn-dark border-right"><i className="fas fa-file-excel" />&nbsp;Excel Download</button>
                                <button type="button" className="btn py-1 btn-dark border-left" data-toggle="modal" data-target="#exampleModal">
                                    <i className="far fa-copy" /> STB- 2313
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="card-body p-0">
                                  <table
  id="myTable"
  className="table table-bordered table-dark table-responsive"
>                            <thead className="bg-gradient-navy">
                                <tr>
                                    {/* Table headers with sorting functionality */}
                                    <th>Sl_No</th>

                                    <th>
                                        Network Name
                                    </th>
                                  
                                    <th>Total Customers</th>
                                    <th>Unpaid Customers</th>
                                    <th>Paid Customers</th>
                                    <th>Pay Amount</th>
                                    <th>Collected Amount</th>
                                    <th>Discount Amount</th>
                                    <th>Advance Amount</th>
                                    <th>CM Amount</th>
                                    <th>PM Amount</th>
                                    <th>New Connection</th>
                                    <th>Shifting Connection</th>
                                    <th>Replace Box</th>
                                   
                                    <th>Month & Year</th>
                                  
                                </tr>
                            </thead>
                            <tbody>
                                {filteredRows.length > 0 ? (
                                    filteredRows.map((row, index) => (
                                        <tr key={index} style={{ backgroundColor: row.Pay === "unpaid" ? "#ffd9de" : "#cffcd0" }}>
                                            <td>{row.Sl_No}</td>
                                            <td>{row.Pay}</td>
                                          
                                            <td>{row.Mobile_No}</td>
                                            <td>{row.Pay_Status}</td>
                                            <td>{row.Plan_Amount}</td>
                                            <td>{row.Paid_Amount}</td>
                                            <td>{row.Paid_Date}</td>
                                            <td>{row.Balance_Amount}</td>
                                            <td>{row.Discount_Amount}</td>
                                            <td>{row.Advance_Amount}</td>
                                            <td>{row.Pending_Amount}</td>
                                            <td>{row.Staff_Code}</td>
                                            <td>{row.Network}</td>

                                            <td>{row.Packages}</td>
                                           

                                            <td>{row.Collection_Staff}</td>
                                          
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="30">No results found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div className="card-footer">
                        <div className="d-flex justify-content-end">
                            <div className="pagination btn-group border-light">
                                <button className="btn btn-dark border-right" onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} style={{ opacity: currentPage === 1 ? 0.6 : 1 }} ><i className="fas fa-backward" /></button>
                                <button onClick={() => paginate(1)} className={`btn ${currentPage === 1 ? "bg-gradient-green border-light active" : "btn-dark"} border-left`} > 1 </button>
                                {currentPage > 3 && <span className="mx-1">...</span>}
                                {Array.from({ length: 3 }, (_, i) => currentPage - 1 + i)
                                    .filter((page) => page > 1 && page < totalPages)
                                    .map((page) => (
                                        <button key={page} onClick={() => paginate(page)} className={`btn ${currentPage === page ? "bg-gradient-green border-light active" : "btn-dark"}`} style={{ fontWeight: currentPage === page ? "bold" : "normal" }} > {page} </button>
                                    ))}
                                {currentPage < totalPages - 2 && <span className="mx-1">...</span>}
                                {totalPages > 1 && (
                                    <button onClick={() => paginate(totalPages)} className={`btn ${currentPage === totalPages ? "bg-gradient-green border-light active" : "btn-dark"} border-right`} > {totalPages} </button>
                                )}
                                <button className="btn btn-dark  border-left" onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages} style={{ opacity: currentPage === totalPages ? 0.6 : 1 }} > <i className="fas fa-forward"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
               
            </div>
        </div>
    );
}
export default NetworkWiseReport;
